import { Icon } from '../primitives';

/**
 * HeroPagerDots — индикатор слайдов hero carousel.
 * Figma: I318:3127;318:3099 — ряд из N instances иконки sparkle (318:3085),
 * 16×16, gap 4. Активный dot opacity 1.0, неактивные 0.32.
 *
 * Strict-audit §5 closure: hand-crafted 8-pointed star polygon
 * (`M8 1 L9.2 6.8 L15 8...`) — это НЕ Figma-форма. Figma sparkle — это
 * 4-лучевая звезда с вогнутыми bezier-сторонами (hero-sparkle). Replace
 * на <Icon name="sparkle"/> (Figma node 318:3085).
 *
 * Если count <= 1, ничего не рендерим (свайп без смысла).
 *
 * Props:
 *   count  — сколько dots
 *   active — активный индекс
 */
export default function HeroPagerDots({ count, active }) {
  if (count <= 1) return null;

  const dots = Array.from({ length: count }, (_, i) => i);

  return (
    <div
      className="flex items-center gap-1"
      role="tablist"
      aria-label="Hero carousel pager"
    >
      {dots.map((i) => (
        <Icon
          key={i}
          name="sparkle"
          size={16}
          data-role="dot"
          aria-current={i === active ? 'true' : undefined}
          style={{ opacity: i === active ? 1 : 0.32 }}
        />
      ))}
    </div>
  );
}
